export default function cancelFilters({ state }) {
  state.set(['search', 'filters'], state.get(['currentUser', 'searchFilters']));
  state.commit();
}
